import React, { memo } from "react";

const GearIcon: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      data-testid="gear-icon"
    >
      <path
        d="M5.81095 16.5L5.49254 13.94C5.32007 13.8733 5.15768 13.7933 5.00537 13.7C4.85254 13.6067 4.70315 13.5067 4.55721 13.4L2.18905 14.4L0 10.6L2.04975 9.04C2.03648 8.94667 2.02985 8.85653 2.02985 8.7696V8.2296C2.02985 8.1432 2.03648 8.05333 2.04975 7.96L0 6.4L2.18905 2.6L4.55721 3.6C4.70315 3.49333 4.85572 3.39333 5.01493 3.3C5.17413 3.20667 5.33333 3.12667 5.49254 3.06L5.81095 0.5H10.1891L10.5075 3.06C10.6799 3.12667 10.8426 3.20667 10.9954 3.3C11.1477 3.39333 11.2969 3.49333 11.4428 3.6L13.8109 2.6L16 6.4L13.9502 7.96C13.9635 8.05333 13.9701 8.1432 13.9701 8.2296V8.7696C13.9701 8.85653 13.9569 8.94667 13.9303 9.04L15.9801 10.6L13.791 14.4L11.4428 13.4C11.2969 13.5067 11.1443 13.6067 10.9851 13.7C10.8259 13.7933 10.6667 13.8733 10.5075 13.94L10.1891 16.5H5.81095ZM8.0398 11.3C8.80929 11.3 9.466 11.0267 10.01 10.48C10.5539 9.93333 10.8259 9.27333 10.8259 8.5C10.8259 7.72667 10.5539 7.06667 10.01 6.52C9.466 5.97333 8.80929 5.7 8.0398 5.7C7.25705 5.7 6.59688 5.97333 6.0593 6.52C5.52226 7.06667 5.25373 7.72667 5.25373 8.5C5.25373 9.27333 5.52226 9.93333 6.0593 10.48C6.59688 11.0267 7.25705 11.3 8.0398 11.3Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { GearIcon };
